<template>
  <div v-can:[createPermission]>
    <v-btn to="/admins/create" color="accent"
      ><v-icon>mdi-plus</v-icon> إضافة مشرف جديد
    </v-btn>
  </div>
</template>

<script>
import { WRITE_ADMINS_PERMISSION } from "@/core/statics/Permissions";
export default {
  data() {
    return {
      createPermission: WRITE_ADMINS_PERMISSION,
    };
  },
};
</script>
